const data = [
  {
    id: 1,
    image: "https://img.icons8.com/ios/64/000000/menu.png",
    title: "Web Design",
    desc: "I can work with front end development of a Website by HTML, CSS, Bootstrap, Tailwind CSS, Daisy UI etc.",
  },
  {
    id: 2,
    image: "https://img.icons8.com/ios/64/000000/open-book.png",
    title: "Web Development",
    desc: "I can work with front and backend development with React, Node JS, Express JS and MongoDb technologies",
  },
  {
    id: 3,
    image: "https://img.icons8.com/fluency-systems-regular/64/000000/retro-tv.png ",
    title: "App Development",
    desc: "I can do pixel perfect UI development of Android application with React Native.",
  },
  {
    id: 4,
    image: "https://img.icons8.com/material-outlined/64/000000/topic--v1.png ",
    title: "ICT Instruction",
    desc: "I'm experienced with ICT instruction for a long time. I can work as ICT Instructor",
  },
  {
    id: 5,
    image: "https://img.icons8.com/ios-filled/64/000000/wifi.png ",
    title: "Website Maintenance",
    desc: "As a web developer i can also maintain and update website for any need",
  },
  {
    id: 6,
    image: "https://img.icons8.com/glyph-neue/64/000000/polyline.png ",
    title: "Digital Marketing",
    desc: "I have some knowledge of Digital Marketing. I also do Facebook Marketing",
  },
]
export default data
